

import axios from 'axios';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardImage, MDBCardText, MDBCardTitle, MDBChip, MDBCol, MDBIcon, MDBLightbox, MDBLightboxItem, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBRow, MDBSelect, MDBTooltip, MDBTypography } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import * as regex from './../reusables/regex';
import VideoPlayer from './VideoPlayer';

const baseUrl = process.env.REACT_APP_INVENTORY_URL;
export const fetchDocumentMap = async (setDocumentsMap,tokenLoaded,type) => {
 
  if (!tokenLoaded) {return}

  let url = `${baseUrl}/imgs/imageMapCompanyAndType`;
  try {

    if(type){
      url =`${baseUrl}/imgs/imageMapCompanyAndType?type=${type}`;
    }
    const response = await axios.get(url);
    
    if (response.status === 200) {
      setDocumentsMap(response.data);
    } else {
      console.error(`Error: ${response.status}`);
    }
    
  } catch (error) {
    console.error('An error occurred while fetching documents:', error);
  }
};



export const fetchCompanyMap = async (setCompaniesMap,tokenLoaded,type) => {
 
  if (!tokenLoaded) {return}
  
  let url =`${baseUrl}/company/allCompaniesWithReceipts`;
  
  try {
    if(type){
      url =`${baseUrl}/company/allCompaniesWithReceipts?type=${type}`;
    }
    const responseForProcessedEntities = await axios.get(url);    
    if (responseForProcessedEntities.status === 200) {

      setCompaniesMap(responseForProcessedEntities.data);
    } else {
      console.error(`Error: ${responseForProcessedEntities.status}`);
    }
  } catch (error) {
    console.error('An error occurred while fetching documents:', error);
  }
  
};

export const deleteHandle = async (receiptId, setAlertColor,setShowAlert,setAlertMessage,receipts,setReceipts,setActiveTab,setIsNewReceipt,setIsReceiptToBeProcessed,moveCompanyToProcessed,setCompaniesMap,setDocumentsMap,tokenLoaded) => {
   
    const url = `${baseUrl}/imgs/${receiptId}`;
    try {
        const response = await axios.delete(url, {
            withCredentials: true,
        });
        if (response.status === 200) {
             // Add the new category to the existing selectCategories state
    setAlertColor("success");
   setShowAlert(true)
    setAlertMessage('Image deleted successfully');
    const updatedReceipts = receipts.filter(receiptItem => receiptItem.id !== receiptId);
    setReceipts(updatedReceipts);

    // Optionally, switch to the first available receipt after removal
    if (updatedReceipts.length > 0) {
      setActiveTab &&  setActiveTab(updatedReceipts[0].id);
    } else {
        setActiveTab &&  setActiveTab(null);  // No receipt is selected if all are processed
    }
        } else {
            console.error('Failed to delete the image');
        }
    } catch (error) {
        console.error('An error occurred while deleting the image:', error);
    }
    setIsNewReceipt &&  setIsNewReceipt(true);
    setIsReceiptToBeProcessed(false) ;
    moveCompanyToProcessed && moveCompanyToProcessed();

    fetchCompanyMap(setCompaniesMap,tokenLoaded);

    fetchDocumentMap(setDocumentsMap,tokenLoaded);
};






export const PasswordAlertCard = () => {
    return (
        <MDBCard className='mb-3'>
            <MDBCardHeader><MDBCardText> <span className='fw-bold'>Password Requirements</span></MDBCardText></MDBCardHeader>
            
          <MDBCardBody>
          <MDBTypography listUnStyled className='mb-0' style={{ minWidth: '10rem',textAlign: 'left' }}>
      <li  style={{ display: 'flex' }} className='mb-1' >
        <MDBIcon icon='info-circle' className='me-2 mt-1 text-warning' />at least one digit
      </li>
      <li  style={{ display: 'flex' }} className='mb-1'>
        <MDBIcon icon='info-circle' className='me-2 mt-1 text-warning' />one lowercase letter
      </li>
      <li  style={{ display: 'flex' }} className='mb-1'>
        <MDBIcon icon='info-circle' className='me-2 mt-1 text-warning' />one uppercase letter
      </li>
      <li  style={{ display: 'flex' }} className='mb-1'>
        <MDBIcon icon='info-circle' className='me-2 mt-1 text-warning' />8 t0 15 characters long
      </li>
      <li  style={{ display: 'flex' }} className='mb-1'>
  <MDBIcon icon='info-circle' className='me-2 mt-1 text-warning '  /><span className='text-wrap'>No two identical characters appear consecutively.</span>
</li>
    </MDBTypography>
         
        
        </MDBCardBody>
        </MDBCard>
        );
}

export const handlePasswordValidation = (event, newPassword, confirmPassword, setAlertMessage, setAlertColor, setShowAlert) => {
    event.preventDefault();
    if (!validatePassword(newPassword)) {
        setAlertMessage(` <ul style={{ maxWidth: '10rem',textAlign: 'left' }}>
        <h5>Password Requirements</h5>
        <li>at least one digit</li>
        <li>one lowercase letter</li>
        <li>one uppercase letter</li>
        <li>8 t0 15 characters long</li>
        <li>No two identical characters appear consecutively.</li>
    </ul>`);
        setAlertColor('danger');
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 10000);
        return;
    }

    if (newPassword !== confirmPassword) {
        setAlertMessage('Passwords do not match');
        setAlertColor('danger');
        setShowAlert(true);
       // setTimeout(() => setShowAlert(false), 10000);
        return;
    }
      setAlertMessage('You\'ll need to log in again using your updated credentials.');
     setAlertColor("primary");
    
};
export const validatePassword = (password) => {
    return regex.password.test(password);
};





 export   const fetchMainPageData = async (setPageData,setIsPricing, pageData,setBusiness) => {
  if(pageData){
    return;
  }
  
      try {
        const res = await axios.get(`${baseUrl}/mainpagedata`);
      
        setPageData(res.data);
        localStorage.setItem('LOGO', res?.data?.logo);
        setIsPricing(res.data.isPricing);
        localStorage.setItem("BUSINESS",res.data.business);
        setBusiness(res.data.business);
        localStorage.setItem("isPricing", res.data.isPricing);

      } catch (error) {
        console.error("Page data not found in Mongo DB", error);
      
      }
    }
 export   const handleAllowLocation = async (setLocation,_ipAddress,setIPAddress) => {

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          setLocation(coords);
          //  sendToServer(coords);
        }, (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            const browser = getBrowserName();
            let message = "You have blocked location access. ";
  
            switch (browser) {
              case "Chrome":
                message += "In Chrome, go to Settings > Privacy and security > Site settings > Location and allow location access for this site.";
                break;
              case "Firefox":
                message += "In Firefox, click on the 'i' or padlock in the address bar, then click on the 'x' next to 'Blocked' under Permissions > Access Your Location.";
                break;
              // Add guidance for other browsers if desired
              default:
                message += "Please enable it in your browser settings to use this feature.";
            }
  
            alert(message);
            fetchIPAddress(setIPAddress);
          } else {
            console.error("Error Code = " + error.code + " - " + error.message);
            fetchIPAddress(setIPAddress);
          }
        });
      } else {
        alert("Geolocation is not supported by this browser.");
        fetchIPAddress(setIPAddress);
      }
    }
  


 function getBrowserName() {
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  } // Add detections for other browsers as needed
  return "Unknown";
}

 
export const fetchIPAddress = async (setIPAddress) => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    setIPAddress(data.ip);
    localStorage.setItem('ipAddress', JSON.stringify(data.ip));
  } catch (error) {
    console.error("Error fetching IP address:", error);
  }
};
export const getDomainsAndCategories = async (
  domainId,
  location,
  ipAddress,
  tokenLoaded,
  setBusiness,
  setCountry,
  setSelectCategories,
  setSelectDomains,
  setGroupedCategoriesByDomain,
  setCategoryImages,
  setGroupedDomainsByDomain,
  setDomainImages,
  setDomainId,
  setFirmId
) => {
  let latLngQuery = "";
  if (location) {
    console.log(`Latitude: ${location?.latitude}, Longitude: ${location?.longitude}`);
    latLngQuery = `?latitude=${location?.latitude}&longitude=${location?.longitude}`;
  } else {
    latLngQuery = `?ipAddress=${ipAddress || localStorage.getItem('ipAddress')}`;
  }

  if (latLngQuery && ipAddress && ipAddress !== 'undefined') {
    try {
      if (tokenLoaded && !domainId) {
        return;
      }

      let url = (tokenLoaded || localStorage.getItem("JWT-TOKEN"))
        ? domainId && `${baseUrl}/domains/domainToCategories/${domainId}`
        : `${baseUrl}/domains/domainToCategories/byhost`;

      url += latLngQuery;

      const domainCategoryResponse = await axios.get(url);
      if (domainCategoryResponse.status === 200) {
        const response = domainCategoryResponse.data;

        let newSelectDomains = [];
        let newSelectCategories = [];
        let categoryImages = {};
        let domainImages = {};

        for (let key in response) {
          const domainIdMatch = key.match(/\{(\w+)=/);
          const domainNameMatch = key.match(/name=([^,}]+)/);
          const businessMatch = key.match(/business=([^,}]+)/);
          const countryMatch = key.match(/country=([^,}]+)/);
          const isFirmMatch = key.match(/isFirm=([^,}]+)/);

          if (!domainIdMatch || !domainNameMatch) {
            console.error('Invalid key structure in response:', key);
            continue;
          }

          const domainId = domainIdMatch[1];
          const domainName = domainNameMatch[1];
          const business = businessMatch ? businessMatch[1] : undefined;
          const country = countryMatch ? countryMatch[1].toUpperCase() : undefined;
          const isFirm = isFirmMatch ? isFirmMatch[1] === 'true' : false;

          if (isFirm) {
            setFirmId(domainId);
          }

          setBusiness(business);
          setDomainId(domainId);
          setCountry(country);
          localStorage.setItem("BUSINESS", business || 'B2C');
          localStorage.setItem('DOMAIN', domainId);

          if (isFirm) {
            localStorage.setItem('FIRM', domainId);
          }

          const imagesMatch = key.match(/images=\[(.*?)\]/);
          const images = imagesMatch ? imagesMatch[1].split(",") : [];
          domainImages[domainId] = images;

          newSelectDomains.push({ value: domainId, text: domainName });

          response[key].forEach((categoryObj) => {
            for (let categoryKey in categoryObj) {
              const categoryValue = Object.keys(categoryObj[categoryKey])[0];
              const categoryImage = categoryObj[categoryKey][categoryValue];
              if (!newSelectCategories.find(category => category.text === categoryValue)) {
                categoryImages[categoryValue] = categoryImage;
                newSelectCategories.push({ value: categoryKey, text: categoryValue });
              }
            }
          });
        }

        if (!domainId) {
          setDomainImages(domainImages);
        }

        setSelectDomains(newSelectDomains);
        setSelectCategories(newSelectCategories);
        setCategoryImages(categoryImages);

        if (domainId) {
          setGroupedDomainsByDomain((prevGroupedDomains) => ({
            ...prevGroupedDomains,
            [domainId]: newSelectDomains,
          }));
          setGroupedCategoriesByDomain((prevGroupedCategories) => ({
            ...prevGroupedCategories,
            [domainId]: newSelectCategories,
          }));
        }
      }
    } catch (error) {
      console.error('Error retrieving domains and categories:', error);
    }
  }
};


// export const getDomainsAndCategories = async (domainId,location,ipAddress,tokenLoaded,setBusiness,setCountry,setSelectCategories,setSelectDomains,setGroupedCategoriesByDomain,setCategoryImages,setGroupedDomainsByDomain,setDomainImages,setDomainId,setFirmId) => {
           
  

//   let latLngQuery = "";
//   if(location) {
//       console.log(`Latitude: ${location?.latitude}, Longitude: ${location?.longitude}`);
//       latLngQuery = `?latitude=${location?.latitude}&longitude=${location?.longitude}`;
//   } else {
    
//       latLngQuery = `?ipAddress=${ipAddress || localStorage.getItem('ipAddress')}`;
//   }

//   if(latLngQuery && ipAddress && ipAddress!=='undefined'){
//   try {
// if(tokenLoaded && !domainId){
// return ;
// }

//     let url = (tokenLoaded|| localStorage.getItem("JWT-TOKEN"))
//       ? domainId && `${baseUrl}/domains/domainToCategories/${domainId}`
//       : `${baseUrl}/domains/domainToCategories/byhost`;

//        url = url + latLngQuery;

//     const domainCategoryResponse = await axios.get(url);
//     if (domainCategoryResponse.status === 200) {
//       const response = domainCategoryResponse.data;

//       let newSelectDomains = [];
//       let newSelectCategories = [];
//       let categoryImages = {}; // Initialize as an empty object
//       let domainImages = {}; // Initialize domain images as an empty object

//       for (let key in response) {
//         domainId = key.match(/\{(\w+)=/)[1]; // Extract domainId
//         let domainName = key.match(/name=([^,}]+)/)[1];
        


//         let business = undefined;
//         let country = undefined;
//         let isFirm = undefined;
//         // Check if the key contains the 'business' and 'country' keys
//         if (key.includes('business=') && key.includes('country=')) {
//             business = key.match(/business=([^,}]+)/)[1];
//             country = key.match(/country=([^,}]+)/)[1];
//         }
//         // Check if the key contains the 'business' and 'country' keys
//         if (key.includes('isFirm=') ) {
//           isFirm = key.match(/isFirm=([^,}]+)/)[1];
         
//       }

//       isFirm && setFirmId(domainId);

//         // const business = key.match(/business=([^,}]+)/)[1];
//         // const country = key.match(/country=([^,}]+)/)[1];
//         setBusiness(business);
//         setDomainId(domainId);
        
//         setCountry(country?.toUpperCase());
//         localStorage.setItem("BUSINESS", business ||'B2C');
//     //   if(business==='B2C'){
         
//         localStorage.setItem('DOMAIN', domainId);    
//           localStorage.setItem('FIRM', domainId);
// //}


//         let imagesString = key.match(/images=\[(.*?)\]/)[1]; // Extract images
//         let images = imagesString ? imagesString.split(",") : []; // Convert images to array

//         domainImages[domainId] = images; // Add images to domainImages

//         newSelectDomains.push({ value: domainId, text: domainName });

//         response[key].forEach((categoryObj) => {
//           for (let categoryKey in categoryObj) {
//             let categoryValue = Object.keys(categoryObj[categoryKey])[0]; // Get the category name
//             let categoryImage = categoryObj[categoryKey][categoryValue]; // Get the category image  
//             // check if category already exists in newSelectCategories
//             let categoryExists = newSelectCategories.find(category => category.text === categoryValue);
//             if (!categoryExists) {
//               // if category does not exist, add it
//               categoryImages[categoryValue] = categoryImage; // Assign the image directly to the object using the category name as key
//               newSelectCategories.push({ value: categoryKey, text: categoryValue });
//             }
//           }
//         });
//       }
//       if (!domainId) {
//         setDomainImages && setDomainImages(domainImages);
//       }
//       setSelectDomains(newSelectDomains);
//       setSelectCategories(newSelectCategories);
//       setCategoryImages(categoryImages); // Set the category images in the state

//       if (domainId) {
//         setGroupedDomainsByDomain((prevGroupedDomains) => ({
//           ...prevGroupedDomains,
//           [domainId]: newSelectDomains,
//         }));
//         setGroupedCategoriesByDomain((prevGroupedCategories) => ({
//           ...prevGroupedCategories,
//           [domainId]: newSelectCategories,
//         }));
//       }
//     }

    
//    // setShowWait(false);
//   } catch (error) {
//    // setShowWait(false);
//     console.error('Error retrieving domains and categories:', error);
//   }
// }
// };


const transformGroupsWithIndentation = (groups) => {
  const result = [];

  const calculateIndentation = (groupDn) => {
    if (!groupDn || typeof groupDn !== "string") {
      console.warn("Invalid groupDn:", groupDn);
      return "";
    }
    const depth = (groupDn.match(/cn=/g) || []).length;
    return ".. ".repeat(depth - 1);
  };

  const processGroup = (group) => {
    if (!group || !group.groupName || !group.groupDn) {
      console.warn("Skipping invalid group:", group);
      return;
    }
    const indentation = calculateIndentation(group.groupDn);
    result.push({
      text: `${indentation}${group.groupName}`,
      value: group.groupDn,
    });

    if (group.subGroups && Array.isArray(group.subGroups)) {
      group.subGroups.forEach((subGroup) => processGroup(subGroup));
    }
  };

  groups.forEach((group) => processGroup(group));
  return result;
}
export  const fetchRoles = async (setRoles,setError) => {
  try {

 
    const response = await axios.get(`${baseUrl}/users/roles/all`);  setRoles([]); // Prevent undefined state
    setRoles(response.data || []);
  } catch (err) {
    setRoles([]); // Prevent undefined state
    console.error('Error fetching roles:', err);
    setError('Failed to fetch roles. Please try again later.');
  }
};

export const fetchUserProfile = async (setUserProfile, setUid, setAddresses, setEmails, setPhones, tokenLoaded, setGroups,setRoles,setTitles) => {
  if (tokenLoaded) {
    try {
      const userData = await axios.get(`${baseUrl}/userprofiles`).then(res => res.data);
      setUserProfile(userData);
        // Extract domain ID from `dn` in userData
        const userDomain = userData.dn
        .split(",")
        .reduce((domain, part, index, parts) => {
          if (part.startsWith("ou=users")) {
            const nextPart = parts[index + 1];
            if (nextPart?.startsWith("ou=")) {
              return nextPart.substring(3); // Extract value after "ou="
            }
          }
          return domain;
        }, null);

      // Find the groups for the matching domain
      const groups =
        userDomain && userData.domainToGroupMap
          ? transformGroupsWithIndentation(userData.domainToGroupMap[userDomain]) || [] // Use groups from the matched domain
          : [];

    
        setGroups(groups); // Extract group names
      setUid(userData.uid);
      
      localStorage.setItem("uid", userData.uid);
      localStorage.setItem("groups", JSON.stringify(userData.groups));
      
      // Fetch and set addresses, phones, and emails
      await fetchAndSetData('addresses', userData.street, setAddresses);
      await fetchAndSetData('phones', userData.telephoneNumber, setPhones);
      await fetchAndSetData('emails', userData.email, setEmails);
      await fetchAndSetData('roles', userData.roles, setRoles);
      await fetchAndSetData('titles', userData.titles, setTitles);
    } catch (userProfileError) {
      console.error('Error fetching user profile:', userProfileError);
    }
  }
};

const fetchAndSetData = async (type, id, setter) => {
  if (id) {
    try {
      const response = await axios.get(`${baseUrl}/${type}/${id}`).then(res => res.data);
      const dataArray = Array.isArray(response) ? response.flat() : [response];
      
      setter(prevData => {
        // Flatten any nested arrays in prevData
        const flattenedPrevData = prevData.flat();
        // Ensure unique entries by checking the existing ids
        const existingIds = new Set(flattenedPrevData.map(item => item.id));
        const newData = dataArray.filter(item => !existingIds.has(item.id));
        
        // Update the existing entry if needed and add new unique entries
        return [...flattenedPrevData, ...newData].map(item => {
          const newItem = dataArray.find(d => d.id === item.id);
          return newItem || item;
        });
      });
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
    }
  }
};

 
export const fetchCart = async (cartId, setCartCount, setCartId, tokenLoaded, ipAddress, _setQty, _setWeight) => {
  if (!ipAddress && !localStorage.getItem('ipAddress')) {
    return;
  }
  let cartUrl;
  if (tokenLoaded) {
    cartUrl = cartId ? `${baseUrl}/cart/${cartId}` : `${baseUrl}/cart`;
  } else {
    cartUrl = cartId ? `${baseUrl}/cart/anonymous/${cartId}` : null;
  }
  cartUrl = cartUrl && cartUrl + `?ipAddress=${ipAddress || localStorage.getItem('ipAddress')}`;
  if (cartUrl) {
    try {
      const cartResponse = await axios.get(cartUrl);
      const cart = cartResponse.data;
      if (cart && cart.entityIdToQty) {
        const count = cart.totalQty;
        setCartCount(count);
        setCartId(cart.id);

      
      }
    } catch (error) {
      setCartCount(0);
      setCartId(null);
      console.error("Error in fetchItems:", error);
    }
  }
};



export const usePersistedState = (key, defaultValue, tokenLoaded) => {
  const [state, setState] = useState(() => {
    const persistedValue = localStorage.getItem(key);
    if (persistedValue === null || persistedValue === "undefined") {
      // If no item or "undefined" string is found, use the default value
     // console.log(`No persisted state or invalid value found for key: ${key}, using defaultValue:`, defaultValue);
      return defaultValue;
    }
    try {
      return JSON.parse(persistedValue);
    } catch (error) {
      // Log and use the default value if JSON parsing fails
      console.error(`Error parsing persisted state for key: ${key}, using defaultValue:`, defaultValue, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    // Only persist to localStorage if state is not undefined
    if (state !== undefined && tokenLoaded) {
      localStorage.setItem(key, JSON.stringify(state));
    }
  }, [tokenLoaded, key, state]);

  return [state, setState];
};




export const fetchImages = async (setImages, images, tokenLoaded,isImagesLoading,setIsImagesLoading) => {
  if(!isImagesLoading){
  if (tokenLoaded && images.length === 0) {
    setIsImagesLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/imgs/otherThanReceipt`);
 
      setImages(response.data);
    } catch (error) {
      console.error("Error in fetchImages: ", error);  // log the error
    }
  }
  setIsImagesLoading(false);
}
};



export const fetchOriginalNames = async (setOriginalNames,tokenLoaded) => {
  
  if (tokenLoaded ) {
    try {
      const response = await axios.get(`${baseUrl}/originalname/names`);
      setOriginalNames(response.data);
    
    } catch (error) {
      console.error("Error in fetch setOriginalNames: ", error);  // log the error
    }
  }


};


export const fetchEntityNames = async (setNames,tokenLoaded) => {
  
  if (tokenLoaded ) {
    try {
      const response = await axios.get(`${baseUrl}/entities/names`);
      setNames(response.data);
    
    } catch (error) {
      console.error("Error in fetch entity Names: ", error);  // log the error
    }
  }


};


export const fetchCompanyNames = async (setCompanyNames,tokenLoaded) => {
  
  if (tokenLoaded ) {
    try {
      const response = await axios.get(`${baseUrl}/company/names`);
      setCompanyNames(response.data);
    
    } catch (error) {
      console.error("Error in fetch Company Names : ", error);  // log the error
    }
  }


};

export const generateQtnAnsPDF = (formId) => {
  // Get the form and button container elements
  const formContainer = document.getElementById(formId);
  const buttonContainers = formContainer.querySelectorAll('.button-container'); // Get all button containers

  // Temporarily hide all elements with class 'button-container'
  buttonContainers.forEach(container => container.style.display = 'none');

  const pdf = new jsPDF();

  // Generate the PDF
  html2canvas(formContainer).then((canvas) => {
    const image = canvas.toDataURL('image/png');
    pdf.addImage(image, 'PNG', 0, 0, 210, 297); // A4 size paper dimensions

    // Save the PDF
    pdf.save(`${formId}.pdf`);

    // Restore visibility of the button containers after PDF generation
    buttonContainers.forEach(container => container.style.display = '');
  }).catch((err) => {
    console.error('Error generating PDF:', err);
  });
};




export const useTruncateToggle = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const maxHeight = 60; // Max height in pixels for approximately 3 lines
        if (textRef.current.scrollHeight > maxHeight) {
          setIsTruncated(true);
        } else {
          setIsTruncated(false);
        }
      }
    };

    checkTruncation();

    // Add event listener to check truncation on window resize
    window.addEventListener('resize', checkTruncation);

    // Cleanup the event listener
    return () => window.removeEventListener('resize', checkTruncation);
  }, [textRef]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return {
    isExpanded,
    isTruncated,
    toggleExpanded,
    textRef,
  };
};
// Recursive function to sort paragraphs based on orderNumber, and their nested paragraphs as well.
const sortParagraphs = (paragraphs) => {
  if (!Array.isArray(paragraphs)) return paragraphs;

  // Sort paragraphs at the current level based on orderNumber
  const sortedParagraphs = paragraphs
    .filter((p) => p.orderNumber >= 0) // Filter out paragraphs with no valid order number
    .sort((a, b) => a.orderNumber - b.orderNumber);

  // Recursively sort nested paragraphs
  return sortedParagraphs.map((paragraph) => ({
    ...paragraph,
    paragraphs: sortParagraphs(paragraph.paragraphs || []), // Recursively sort nested paragraphs
  }));
};


const renderParagraphs = (paragraphs, level = 0) => {
  if (!paragraphs || paragraphs.length === 0) return null;

  const sortedParagraphs = sortParagraphs(paragraphs);

  return (
    <div className="rounded">
      {sortedParagraphs?.map((paragraph, index) => {
        // Always call useTruncateToggle for each paragraph to maintain hook order
        const { isExpanded, isTruncated, toggleExpanded, textRef } = useTruncateToggle();

        return (
          <div key={`${index}-${level}`} className={`w-100 mb-2 ${index > 0 ? 'px-lg-5' : ''} px-md-5 ps-0`}>
            <p className="mt-1 ms-3 text-start text-black">
              {paragraph.type === 'link' ? (
                <a href={paragraph.textValue} target="_blank" rel="noopener noreferrer">
                  <MDBBtn
                    type="button"
                    color="link"
                    rippleColor="dark"
                    className={`${paragraph.heading?.textColor || 'text-dark'} text-start fw-bold mb-1 text-capitalize`}
                  >
                    {paragraph.textValue}
                  </MDBBtn>
                </a>
              ) : paragraph.type === 'caption' ? (
                <MDBChip
                  size="md"
                  className="align-items-center text-center justify-content-center flex-wrap w-100"
                  style={{
                    minHeight: '40px',
                    height: 'auto',
                    width: '100%',
                    padding: '10px',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word',
                  }}
                >
                  {paragraph.heading?.image && (
                    <img
                      style={{
                        width: '40px',
                        height: '40px',
                        marginRight: '10px',
                      }}
                      src={paragraph.heading?.image}
                      alt="caption"
                    />
                  )}
                  <figure className="mb-0">
                    {paragraph.heading?.textValue && (
                      <MDBTypography
                        tag={`${paragraph.heading?.textSize || 'h4'}`}
                        variant={paragraph.heading?.textSize || 'h5'}
                        className={`${paragraph.heading?.textColor || 'text-dark'} fw-bold mb-1 text-capitalize`}
                      >
                        {paragraph.heading.textValue}
                      </MDBTypography>
                    )}
                    {paragraph.textValue && (
                      <figcaption className="blockquote-footer mb-0">
                        <cite title="Source Title" className={`${paragraph?.textColor || 'text-success'} fw-bold`}>
                          {paragraph.textValue}
                        </cite>
                      </figcaption>
                    )}
                  </figure>
                </MDBChip>
              ) : (
                <>
                  {paragraph.heading?.textValue && (
                    <MDBTypography
                      tag={`${paragraph.heading?.textSize || 'h1'}`}
                      variant={paragraph.heading?.textSize || 'h1'}
                      className={`${paragraph.heading?.textColor || 'text-success'} text-start mb-0 text-capitalize`}
                      style={{ color: paragraph.heading?.textColor }}
                    >
                      {paragraph.heading.textValue}
                    </MDBTypography>
                  )}
                  {paragraph.textValue && (
                    <span ref={textRef} className={`text-${paragraph?.textColor ? paragraph.textColor : 'dark'} `}>
                      {isTruncated && !isExpanded ? `${paragraph.textValue.slice(0, 100)}...` : paragraph.textValue}
                    </span>
                  )}
                  {isTruncated && (
                    <MDBBtn type="button" size="sm" color="link" className="mt-2 text-lowercase" onClick={toggleExpanded}>
                      {isExpanded ? 'Show Less' : 'Show More'}
                    </MDBBtn>
                  )}
                </>
              )}
            </p>

            {paragraph.paragraphs && paragraph.paragraphs.length > 0 && renderParagraphs(paragraph.paragraphs, level + 1)}
          </div>
        );
      })}
    </div>
  );
};

export const generateParagraphId = (parentId = '', text = '', index = 0, type = 'pgs', featureName = '', featureIndex = 0) => {
  const textPart = toCamelCase(String(text || ''));
  if (!parentId) {
    const featurePart = `fe_${toCamelCase(featureName)}#${featureIndex}`;
    return `${featurePart}-${type}_${textPart}#${index}`;
  }
  return `${parentId}-${type}_${textPart}#${index}`;
};

// Updated `toCamelCase` function
export const toCamelCase = (str = '') => {
  return str
    .replace(/\s(.)/g, (match) => match.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, (match) => match.toLowerCase())
    .substring(0, 15);
};



export const renderDescriptions = (descriptions) => {
  return descriptions.map((description, descIndex) => {
    // Sort the paragraphs in each description
    const sortedParagraphs = sortParagraphs(description.paragraphs || []);

    return (
      <div key={descIndex} className="description-block">
        {/* Render caption if applicable */}
        {description.type === 'caption' ? (
          <MDBChip
            size="md"
            className="align-items-center text-center justify-content-center flex-wrap w-100"
            style={{
              minHeight: '40px',
              height: 'auto',
              width: '100%',
              padding: '10px',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              overflowWrap: 'break-word',
            }}
          >
            {description.heading?.image && (
              <img
                style={{
                  width: '40px',
                  height: '40px',
                  marginRight: '10px',
                }}
                src={description.heading?.image}
                alt="caption"
              />
            )}
            <figure className="mb-0">
              {description.heading?.textValue && (
                <MDBTypography
                  tag={`${description.heading?.textSize || 'h4'}`}
                  variant={description.heading?.textSize || 'h5'}
                  className={`${description.heading?.textColor || 'text-dark'} fw-bold mb-1 text-capitalize`}
                >
                  {description.heading.textValue}
                </MDBTypography>
              )}
              <figcaption className="blockquote-footer mb-0">
                <cite className={`${description?.textColor || 'text-success'} fw-bold mb-1`} title="Source Title">
                  {description.textValue}
                </cite>
              </figcaption>
            </figure>
          </MDBChip>
        ) : (
          <>
            {/* Display main description text */}
            {description.textValue && (
              <p className={`${description?.textColor || 'text-success'} fw-bold mb-1`}>{description.textValue}</p>
            )}
          </>
        )}
        {/* Recursively render sorted paragraphs */}
        {sortedParagraphs.length > 0 && renderParagraphs(sortedParagraphs)}
      </div>
    );
  });
};

export const themeColors = [
  { text: 'Primary', value: 'primary' },
  { text: 'Secondary', value: 'secondary' },
  { text: 'Success', value: 'success' },
  { text: 'Info', value: 'info' },
  { text: 'Warning', value: 'warning' },
  { text: 'Danger', value: 'danger' },
  { text: 'Light', value: 'light' },
  { text: 'Dark', value: 'dark' },
  { text: 'Muted', value: 'muted' },
];

export const textTypes = [
  { text: 'Text', value: 'text' },
  { text: 'Link', value: 'link' },
  { text: 'Caption', value: 'caption' }
];

export const fonts = [
  { text: 'fs-1', value: 'fs-1' },
  { text: 'fs-2', value: 'fs-2' },
  { text: 'fs-3', value: 'fs-3' },
  { text: 'fs-4', value: 'fs-4' },
  { text: 'fs-5', value: 'fs-5' },
  { text: 'fs-6', value: 'fs-6' }
];

export const headers = [
  { text: 'h1', value: 'h1' },
  { text: 'h2', value: 'h2' },
  { text: 'h3', value: 'h3' },
  { text: 'h4', value: 'h4' },
  { text: 'h5', value: 'h5' },
  { text: 'h6', value: 'h6' }
];
export const categoriesOfQtns = [
  { text: 'dreamstate', value: 'DreamState' },
  { text: 'currentstate', value: 'CurrentState' },
  { text: 'obstacle', value: 'ObstacleState' },
  { text: 'skills', value: 'SkillsState' },
  { text: 'help', value: 'HelpState' },
  { text: 'custom', value: 'Custom' },



];



export const CustomSelect = ({ label, data = [], selected, onValueChange }) => {
  // If data is not an array, ensure it defaults to an empty array
  const options = Array.isArray(data) ? data.map(item => ({
    text: item.text || 'Unknown',  // Provide fallback value for text
    value: item.value || ''        // Provide fallback value for value
  })) : [];

  // Handle change event and pass selected value
  const handleChange = (selectedData) => {
    const selectedOption = Array.isArray(selectedData) ? selectedData[0] : selectedData;
    if (selectedOption && onValueChange) {
      onValueChange(selectedOption);
    }
  };

  return (
    <MDBSelect
      contrast
      label={label}
      options={options}  // Use the processed options array
      value={selected}   // Set the selected value
      onChange={handleChange}  // Handle the selection change
    />
  );
};

CustomSelect.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  selected: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

CustomSelect.defaultProps = {
  data: [],  // Default to an empty array if no data is passed
};


export const FeatureList =({ formData, isEdit, removeFeature }) => {
  const tokenLoaded = true; // Placeholder for your token logic

  return (
    <div className="container my-5 py-5">
      {/* Section Heading */}
      <h2 className="fw-bold mb-7 text-center">Feature List</h2>

      {/* Feature Grid */}
      <MDBRow className="gx-lg-5">
        {formData.orchestration.map((feature, index) => (
          <MDBCol lg="4" md="6" className="mb-6 mb-lg-0" key={`feature-card-${index}`}>
            <MDBCard className="shadow-2-strong">
              <div
                className="bg-image hover-overlay shadow-4-strong rounded mx-3"
                data-mdb-ripple-color="light"
                style={{ marginTop: '-15px' }}
              >
                {/* Feature Image */}
                <MDBCardImage
                  src={feature.imageUrl || 'https://mdbcdn.b-cdn.net/img/new/standard/city/024.webp'}
                  className="img-fluid"
                  style={{ maxHeight: '200px' }}
                />
                <a href="#!">
                  <div className="mask" style={{ backgroundColor: 'rgba(251, 251, 251, 0.15)' }}></div>
                </a>
              </div>
              {/* Card Body */}
              <MDBCardBody>
                <MDBCardTitle>{feature.name || 'Feature Title'}</MDBCardTitle>
                
                <MDBCardText>
                  {feature.paragrapDescriptions && feature.paragrapDescriptions.length > 0
                    ? feature.paragrapDescriptions[0].textValue : 'Description not available.'}
                </MDBCardText>
                <MDBBtn href="#!" className="btn btn-primary btn-rounded">
                  Read more
                </MDBBtn>
                {/* Delete Button for Edit Mode */}
                {isEdit && tokenLoaded && (
                  <MDBBtn
                    tag="a"
                    color="danger"
                    floating
                    className="position-absolute end-0 mb-2 ms-2"
                    style={{ bottom: '10px' }}
                    type="button"
                    onClick={() => removeFeature(index)}
                  >
                    <MDBTooltip tag="a" wrapperProps={{ href: '#' }} title="Remove Feature">
                      <MDBIcon fas icon="times-circle" color="light" />
                    </MDBTooltip>
                  </MDBBtn>
                )}
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        ))}
      </MDBRow>

     
    </div>
  );
}
FeatureList.propTypes = {
  formData:PropTypes.object,
  isEdit:PropTypes.bool,
  addFeature:PropTypes.func,
  removeFeature:PropTypes.func, 
  handleChange:PropTypes.func, 
  handleAddDescription:PropTypes.func, 
  handleRemoveDescription:PropTypes.func
}
export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};
// Deep merge utility for nested properties
export const deepMerge = (target, source) => {
  if (typeof target === 'object' && typeof source === 'object') {
    for (const key in source) {
      if (source[key] && typeof source[key] === 'object') {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return target;
};

export const ImageDisplay = ({ feature, modalOpen,  toggleModal }) => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <MDBBtn
        tag="a"
        color="none"
        className="mx-1 rounded"
        style={{ color: '#55acee' }}
        onClick={toggleModal}
        type="button"
      >
          <MDBIcon far icon="images" />
       
      </MDBBtn>

      <MDBModal open={modalOpen} onClick={(e) => e.preventDefault()} tabIndex="-1" size="lg" nonInvasive>
        <MDBModalDialog centered size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{feature.name} images</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={toggleModal} type="button"></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {feature.imageType === 'carousel' ? (
                <MDBLightbox key={feature?.imageUrls?.length}>
                  <div className="d-flex flex-wrap justify-content-center">
                    {feature?.imageUrls?.map((url, urlIndex) => (
                      <MDBLightboxItem
                        key={`carousel-item-child-${urlIndex}`}
                        className="me-2 mt-2 rounded d-block "
                        src={`${url}`}
                        fullscreenSrc={`${url}`}
                        alt={`Slide ${urlIndex + 1}`}
                        style={{
                          width: 'auto',
                          height: 'auto',
                          maxHeight: '300px', // Responsive height on mobile
                        }}
                        onClick={(e) => e.preventDefault()}
                      />
                    ))}
                  </div>
                </MDBLightbox>
              ) : feature.imageType === 'video' ? 
                // <video
                //   src={feature.imageUrl || 'https://opengrit.com/images/xtrkldemo'}
                //   className="img-thumbnail"
                //   alt="Video Preview"
                //   controls
                //   loop
                //   autoPlay
                //   muted
                //   style={{ height: '300px', width: 'auto' }}
                // />
<VideoPlayer videoUrl={feature.videoUrl || 'https://opengrit.com/images/xtrkldemo'}/>
                
              : (
                <MDBLightbox>
                  <MDBLightboxItem
                    style={{ width: '100%', height: 'auto' }}
                    zoomlevel={0.25}
                    src={feature.imageUrl || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
                    fullscreenSrc={feature.imageUrl || 'https://mdbootstrap.com/img/new/standard/city/041.webp'}
                    className="rounded"
                    alt="Feature Image"
                  />
                </MDBLightbox>
              )}
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  );
};


ImageDisplay.propTypes = {
  feature: PropTypes.shape({
    name: PropTypes.string,
    imageType: PropTypes.string,
    imageUrl: PropTypes.string,
    videoUrl: PropTypes.string,
    imageUrls: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  modalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
};



export const updateUserProfile = async (updatedUser, setDomainData) => {
  try {
    const response = await axios.put(`${baseUrl}/userprofiles/${updatedUser.uid}`, updatedUser);
    if (response.status === 200) {
      // Update state with the response data if successful
      setDomainData(prevState => {
        const updatedUsers = prevState.users.map(user => 
          user.uid === updatedUser.uid ? response.data : user
        );
        return { ...prevState, users: updatedUsers };
      });
      return response.data; // Return data in case it's needed in the caller
    } else {
      console.error("Couldn't update the user in the backend");
    }
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

// Delete User
export const deleteUser = async ( domainId, uId, setDomainData) => {
  try {
    const response = await axios.delete(`${baseUrl}/userprofiles/domain/${domainId}/user/${uId}`, {
      withCredentials: true,
    });

    if (response.status === 200) {
      setDomainData(prevState => ({
        ...prevState,
        users: prevState.users.filter(user => user.uid !== uId),
      }));
      return true;
    }
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};